// import ProductNewReview from "../standartComponent/productComponent/productNewReview";
// import css from "../catalog/catalog.module.css";
// import { useState, useEffect } from "react";
// import "../catalog/catalog.css";

// export default function ViewProductCatalog({
//   products,
//   setAddressChanged,
//   setCartCounterC,
//   setLikeCounterC,
// }) {
//   const [visitedProducts, setVisitedProducts] = useState([]);

//   useEffect(() => {
//     // Отримуємо масив відвіданих продуктів з localStorage
//     const visitedProductsFromLocalStorage = JSON.parse(
//       localStorage.getItem("visitedProducts"),
//     );
//     // Перевіряємо, чи масив існує та чи він не пустий
//     if (
//       visitedProductsFromLocalStorage &&
//       visitedProductsFromLocalStorage.length > 0 &&
//       products
//     ) {
//       const selectedProducts = products.filter((product) =>
//         visitedProductsFromLocalStorage.includes(product.uid),
//       );

//       setVisitedProducts(selectedProducts);
//     }
//   }, []);

//   return (
//     <div className="youLikeItWrapNew">
//       <div className="youLikewrapSmall">
//         <h2 className="ProductCatalogH2">Ви нещодавно переглядали</h2>
//         <div className={css.youLikeProductWrap}>
//           {visitedProducts.map((el, index) => {
//             if (index < 3) {
//               return (
//                 <ProductNewReview
//                   key={index}
//                   el={el}
//                   setAddressChanged={setAddressChanged}
//                   setCartCounterC={setCartCounterC}
//                   setLikeCounterC={setLikeCounterC}
//                 />
//               );
//             }
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }
import ProductNewReview from "../standartComponent/productComponent/productNewReview";
import css from "../catalog/catalog.module.css";
import { useEffect, useState } from "react";
import "../catalog/catalog.css";

export default function ViewProductCatalog({
  products,
  visitedProductsVersion,
  setAddressChanged,
  setCartCounterC,
  setLikeCounterC,
}) {
  const [visitedProducts, setVisitedProducts] = useState([]);

  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0) {
      setVisitedProducts([]);
      return;
    }

    try {
      const savedValue = localStorage.getItem("visitedProducts");

      const parsedValue = savedValue ? JSON.parse(savedValue) : [];

      const visitedProductIds = Array.isArray(parsedValue) ? parsedValue : [];

      /*
       * Важливо:
       * проходимо по UID із localStorage,
       * а не фільтруємо загальний products.
       *
       * Так зберігається реальний порядок перегляду.
       */
      const selectedProducts = visitedProductIds
        .map((uid) => products.find((product) => product.uid === uid))
        .filter(Boolean)
        .slice(0, 3);

      setVisitedProducts(selectedProducts);
    } catch (error) {
      console.error("Помилка отримання переглянутих товарів:", error);

      setVisitedProducts([]);
    }
  }, [products, visitedProductsVersion]);

  if (visitedProducts.length === 0) {
    return null;
  }

  return (
    <div className="youLikeItWrapNew">
      <div className="youLikewrapSmall">
        <h2 className="ProductCatalogH2">Ви нещодавно переглядали</h2>

        <div className={css.youLikeProductWrap}>
          {visitedProducts.map((product) => (
            <ProductNewReview
              key={product.uid}
              el={product}
              setAddressChanged={setAddressChanged}
              setCartCounterC={setCartCounterC}
              setLikeCounterC={setLikeCounterC}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
